<section class="order-view-page">
  <a class="back-link" routerLink="/dashboard/orders">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
    <span>К заказам</span>
  </a>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading-card" *ngIf="loading">Загрузка заказа...</div>

  <ng-container *ngIf="order && !loading">
    <header class="order-hero">
      <div>
        <h1>{{ title }}</h1>
        <span>{{ order.event?.name || 'Событие удалено' }}</span>
      </div>
      <strong class="status-pill" [ngClass]="getStatusClass(order.status)">{{ getStatusName(order.status) }}</strong>
    </header>

    <section class="metrics-grid">
      <article class="metric-card">
        <span>Продажа</span>
        <strong>{{ formatMoney(order.total) }}</strong>
      </article>
      <article class="metric-card">
        <span>Закупка</span>
        <strong>{{ formatMoney(purchaseTotal) }}</strong>
      </article>
      <article class="metric-card">
        <span>Наценка</span>
        <strong>{{ formatMoney(markupTotal) }}</strong>
      </article>
      <article class="metric-card">
        <span>Билеты</span>
        <strong>{{ order.items.length }}</strong>
      </article>
      <article class="metric-card">
        <span>Создан</span>
        <strong>{{ formatDate(order.createdAt) }}</strong>
      </article>
      <article class="metric-card">
        <span>Резерв до</span>
        <strong>{{ order.status === 'reserved' ? formatDate(order.reservationExpiresAt) : '—' }}</strong>
      </article>
    </section>

    <section class="content-grid">
      <main class="main-column">
        <section class="info-card">
          <div class="card-heading">
            <h2>Состав заказа</h2>
          </div>
          <table class="items-table">
            <thead>
              <tr>
                <th>Билет</th>
                <th>Закупка</th>
                <th>Продажа</th>
                <th>Наценка</th>
                <th *ngIf="canDownloadTickets">Файл</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of order.items; trackBy: trackById">
                <td><strong>{{ item.ticket?.code || '—' }}</strong></td>
                <td>{{ formatOptionalMoney(item.unitPurchasePrice) }}</td>
                <td>{{ formatMoney(item.unitSalePrice) }}</td>
                <td>{{ formatOptionalMoney(getItemMarkup(item.unitSalePrice, item.unitPurchasePrice)) }}</td>
                <td *ngIf="canDownloadTickets">
                  <button
                    class="ticket-download-button"
                    type="button"
                    [disabled]="isTicketDownloading(item)"
                    [title]="'Скачать билет ' + (item.ticket?.code || item.ticketId)"
                    [attr.aria-label]="'Скачать билет ' + (item.ticket?.code || item.ticketId)"
                    (click)="downloadTicket(item)">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="info-card">
          <div class="card-heading">
            <h2>История статусов</h2>
          </div>
          <div class="status-history">
            <article *ngFor="let statusEvent of order.statusHistory; trackBy: trackById">
              <strong>{{ getStatusName(statusEvent.nextStatus) }}</strong>
              <span>{{ formatDate(statusEvent.createdAt) }}</span>
            </article>
          </div>
        </section>
      </main>

      <aside class="side-column">
        <section class="info-card">
          <h2>Детали</h2>
          <dl>
            <div><dt>Клиент</dt><dd>{{ order.client?.name || 'Клиент удален' }}</dd></div>
            <div><dt>Событие</dt><dd>{{ order.event?.name || 'Событие удалено' }}</dd></div>
            <div><dt>Дата события</dt><dd>{{ formatEventDate(order.event?.startsAt || null) }}</dd></div>
            <div><dt>Оплачен</dt><dd>{{ formatDate(order.paidAt) }}</dd></div>
            <div><dt>Продавец</dt><dd>{{ formatUser(order.receivedByUser) }}</dd></div>
            <div><dt>Способ оплаты</dt><dd>{{ formatPaymentMethod(order.paymentMethod) }}</dd></div>
            <div><dt>Комментарий оплаты</dt><dd>{{ order.paymentReference || '—' }}</dd></div>
          </dl>
        </section>

        <section class="info-card actions-card" *ngIf="order.status === 'reserved'">
          <h2>Действия</h2>
          <a class="primary-link edit-link" [routerLink]="['/dashboard/orders', order.code, 'edit']">Редактировать заказ</a>
          <button class="primary-link" type="button" [disabled]="savingAction" (click)="openPaymentForm()">Подтвердить оплату</button>
          <button class="danger-link" type="button" [disabled]="savingAction" (click)="cancelOrder()">Отменить резерв</button>

          <form class="payment-form" *ngIf="paymentFormVisible" (ngSubmit)="submitPayment()">
            <label>
              <span>Ответственный</span>
              <select class="form-select" name="paymentReceiver" [(ngModel)]="paymentForm.receivedByUserId" required>
                <option value="">Выберите продавца</option>
                <option *ngFor="let participant of order.event?.participants || []; trackBy: trackByParticipant" [value]="participant.userId">{{ getParticipantName(participant) }}</option>
              </select>
            </label>

            <label>
              <span>Оплата</span>
              <select class="form-select" name="paymentMethod" [(ngModel)]="paymentForm.paymentMethod" required>
                <option value="card">Карта</option>
                <option value="bank_account">Расчетный счет</option>
              </select>
            </label>

            <label>
              <span>Комментарий</span>
              <textarea class="form-textarea" name="paymentReference" rows="3" [(ngModel)]="paymentForm.paymentReference"></textarea>
            </label>

            <div class="payment-actions">
              <button class="primary-link" type="submit" [disabled]="!canSubmitPayment">{{ savingAction ? 'Подтверждаем...' : 'Оплата получена' }}</button>
              <button class="secondary-link" type="button" [disabled]="savingAction" (click)="closePaymentForm()">Отмена</button>
            </div>
          </form>
        </section>

        <section class="info-card actions-card" *ngIf="canDownloadTickets">
          <h2>Билеты</h2>
          <button class="primary-link download-link" type="button" [disabled]="downloadingTickets" (click)="downloadAllTickets()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>
            <span>{{ downloadingTickets ? 'Скачиваем...' : 'Скачать билеты' }}</span>
          </button>
          <p class="actions-note">Скачаются только билеты из состава этого заказа.</p>
        </section>
      </aside>
    </section>
  </ng-container>
</section>
